import { atom } from 'jotai';

export const internalNotesCountAtom = atom<number | null>(null);

export const selectedTeamMemberIdsAtom = atom<Set<string>>(new Set<string>());
